import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { SelectMenu } from 'components/patterns/Inputs'
import { Icon } from 'components/patterns'

export const StyledEditorRow = styled.div`
  display: flex;
`

export const StyledResetAttempts = styled(SelectMenu)`
  margin-left: 15px;
`

export const InfoIcon = styled(Icon)`
  fill: ${themeColor('blackSecondary')};
  &&& {
    height: 14px;
    width: 24px;
    top: 12px;
    left: 13px;
  }
`

export const AsamCurrentMessage = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  margin-bottom: 15px;
`
